import { useTranslation } from 'next-i18next';
import { cn } from '@/utils/tailwind.util';
export enum ClassroomListTab {
  OWNED_CLASSROOMS = 'OWNED_CLASSROOMS',
  JOINED_CLASSROOMS = 'JOINED_CLASSROOMS',
}
export const CLASSROOM_LIST_TABS: Array<{
  value: ClassroomListTab;
  labelKey: 'classroomList.tab.owned' | 'classroomList.tab.joined';
}> = [{
  value: ClassroomListTab.OWNED_CLASSROOMS,
  labelKey: 'classroomList.tab.owned'
}, {
  value: ClassroomListTab.JOINED_CLASSROOMS,
  labelKey: 'classroomList.tab.joined'
}];
export function ClassroomListTabs({
  activeTab,
  onChangeTab,
  tabs = CLASSROOM_LIST_TABS
}: {
  activeTab: ClassroomListTab;
  onChangeTab: (tab: ClassroomListTab) => void;
  tabs?: Array<{
    value: ClassroomListTab;
    labelKey: 'classroomList.tab.owned' | 'classroomList.tab.joined';
  }>;
}) {
  const {
    t
  } = useTranslation(['classroom']);
  return <div className="flex items-start gap-3xs" data-sentry-component="ClassroomListTabs" data-sentry-source-file="ClassroomListTabs.tsx">
      {tabs.map(tab => {
      const isActive = activeTab === tab.value;
      return <button key={tab.value} type="button" onClick={() => onChangeTab(tab.value)} className="flex h-[52px] min-w-[80px] flex-col items-center rounded-t-xs">
            <span className={cn('flex h-[50px] items-center justify-center whitespace-nowrap px-sm text-heading-md-bold', isActive ? 'text-strong' : 'text-assistive')}>
              {t(tab.labelKey)}
            </span>
            {isActive ? <span className="h-[2px] w-full bg-strong" /> : null}
          </button>;
    })}
    </div>;
}